import { ReactElement } from 'react'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { useExpenseRevampFeatureFlags } from '../../hooks/useExpenseRevampFeatureFlags'
import { BillsListLegacy } from './legacy'
import { BillsListRevamped } from './revamped'

export const BillsList = (): ReactElement | null => {
  const { organization } = useUserOrganization()
  const { isRevampedPurchaseListEnabled } = useExpenseRevampFeatureFlags()

  if (!isRevampedPurchaseListEnabled) {
    return <BillsListLegacy />
  }

  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return <BillsListRevamped organizationId={organization!.id} />
}
